import { render, staticRenderFns } from "./AzureWarning.vue?vue&type=template&id=b02ff42c&scoped=true&"
import script from "./AzureWarning.vue?vue&type=script&lang=js&"
export * from "./AzureWarning.vue?vue&type=script&lang=js&"
import style0 from "./AzureWarning.vue?vue&type=style&index=0&id=b02ff42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02ff42c",
  null
  
)

export default component.exports